<template>
    <v-dialog v-model="show" @click:outside="close" width="993">
        <div class="modal video-modal-container">
            <v-btn
              class="close"
              color="#29abe2"
              depressed
              @click="close"
              icon
            ><v-icon>fas fa-times</v-icon>
            </v-btn>
            <v-row>
                <v-col class="icon-modal remove few table-cell" style="max-width: 32px !important;">
                </v-col>
                <v-col class="table-cell video-modal-content">

                    <v-row class="relative">
                        <h6 class="modal-title mt-2 ml-5 mb-4">WATCH VIDEO</h6>
                        <v-spacer></v-spacer>
                    </v-row>

                    <div class="video-modal">
                        <youtube :video-id="videoId" ref="youtube"></youtube>
                    </div>
                </v-col>
            </v-row>
<!--            <v-row>-->
<!--                <v-col cols="1" class="icon-modal remove" style="max-width: 32px!important;"></v-col>-->
<!--                <v-col class="pa-5 text-center pb-0">-->
<!--                    <v-hover>-->
<!--                        <v-card-->
<!--                                outlined-->
<!--                                class="video-modal"-->
<!--                        >-->
<!--                            <youtube :video-id="videoId" ref="youtube"></youtube>-->
<!--                        </v-card>-->
<!--                    </v-hover>-->
<!--                </v-col>-->
<!--            </v-row>-->
<!--            <v-row>-->
<!--                <v-col cols="1" class="icon-modal remove" style="max-width: 32px!important;"></v-col>-->
<!--                <v-col cols="11" style="padding-top: 8px;padding-bottom: 26px; text-align: center">-->

<!--                    <v-btn-->
<!--                            rounded-->
<!--                            depressed-->
<!--                            class="btn-blanco text-center "-->
<!--                            @click="close"-->
<!--                    >Close-->
<!--                    </v-btn>-->
<!--                </v-col>-->
<!--                <v-spacer></v-spacer>-->
<!--            </v-row>-->
        </div>
    </v-dialog>
</template>
<style>

</style>
<script>
    import Vue from 'vue'
    import VueYoutube from 'vue-youtube'

    Vue.use(VueYoutube)

    export default {
        props: ['show', 'hide'],

        data() {
            return {
                videoId: 'PIdHkP5314Y',
            }
        },
        methods: {
            close: function () {
                this.hide();
                this.paused();
            },
            paused() {
                this.player.pauseVideo();
            }
        },
        computed: {
            player() {
                return this.$refs.youtube.player
            }
        }
    };
</script>